import React, { forwardRef } from "react";
import { cn } from "../../lib/utils.js";
import { CARD_BODY_PADDING, useCardSize } from "./card-size.js";

export interface CardBodyProps extends React.HTMLAttributes<HTMLDivElement> {
  /** No padding, for content that runs edge to edge: a list, or a
   *  `TableScroll embedded`. Renders what `className="p-0"` rendered. */
  flush?: boolean;
}

/** The card's content. Its padding comes only from named options (the Card's
 *  `size`, and `flush`); `className` is for layout only (margin, width, gap,
 *  grid). */
export const CardBody = forwardRef<HTMLDivElement, CardBodyProps>(
  function CardBody({ className, children, flush = false, ...rest }, ref) {
    const size = useCardSize();
    return (
      <div
        ref={ref}
        className={cn(flush ? "p-0" : CARD_BODY_PADDING[size], className)}
        {...rest}
      >
        {children}
      </div>
    );
  },
);
